<template>
  <v-data-table
    :loading="loading"
    :headers="filterHeaders"
    :items="items"
    :search="search"
    v-model="selected"
    item-key="_id"
    :select-all="selectAll"
    :class="{'wrap' : wrap}"
    :disable-initial-sort="disableInitalSort"
    :rows-per-page-items="rowsPerPageItems"
    :hide-actions="hideActions"
  >
    <template slot="items" slot-scope="props">
      <td width="20px" v-if="selectAll">
        <v-checkbox v-model="props.selected" color="primary" hide-details></v-checkbox>
      </td>
      <template v-for="item in filterHeadersForBody">
        <td v-if="item.img" class="text-xs-center" :key="item.value"><v-img contain max-height="50px" :src="config.filesUrl + props.item.instance + '/logo/' + props.item[item.value]"></v-img></td>
        <td v-else-if="item.logo" class="text-xs-center" :key="item.value">
          <v-icon v-if="item.logoClick" @click="$emit('logo', props.item[returnValue]) " >{{props.item[item.value]}}</v-icon>
          <v-icon v-else>{{props.item[item.value]}}</v-icon>
        </td>
        <td v-else class="text-xs-center" :key="item.value">
          {{ props.item[item.value] }}
          </td>
      </template>
      <td class="text-xs-center" style="width: 10px" v-if="action">
        <v-btn
          fab
          outline
          dark
          small
          color="primary"
          @click="$emit('edit', props.item[returnValue]) "
        >
          <v-icon dark>edit</v-icon>
        </v-btn>
      </td>
    </template>
    <template v-slot:footer v-if="footer">
      
      <td class="text-xs-center" colspan="3">

      </td>
      <td class="text-xs-center">
        <strong>{{footer.averageGuestDemand}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.averageOrderQuantity}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.range}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.otd}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.delaysDepth}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.averageStock}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.stockCost}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.delayCost}}</strong>
      </td>
      <td class="text-xs-center">
        <strong>{{footer.cost}}</strong>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import Config from '@/config'
export default {
  name: "DataTable",
  props: {
    footer: {
      type: Object,
      default: () => null
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    rowsPerPageItems: {
      type: Array,
      default: function () {
        return [20, 30, 40, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
      }
    },
    returnValue: {
      type: String,
      default: "_id"
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    headers: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    action: {
      type: Boolean,
      default: true
    },
    search: {
      type: String,
      default: ""
    },
    wrap: {
      type: Boolean,
      default: false
    },
    disableInitalSort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: []
    };
  },
  mounted() {},
  computed: {
    filterHeadersForBody () {
      return this.headers.filter(item => item.text !== 'Actions' && item.text !== 'Acciones'  && item.text !== 'Aktionen')
    },
    filterHeaders () {
      if (this.action) return this.headers
      return this.headers.filter(item => item.text !== 'Actions' && item.text !== 'Acciones'  && item.text !== 'Aktionen')
    },
    config () {
      return Config
    }
  },
  watch: {
    selected (val) {
      this.$emit('selected', val)
    }
  }
};
</script>
<style >
  .wrap table.v-table thead th {
    white-space: normal;
    text-align: center;
  }
  tfoot {
    background-color: #1976d230;
    font-size: 1.2rem;
  }
</style>
